export function getLocalStorageKey(pathname: string, context: string) {
  return `${context}-${pathname}`
}

// Helper function to check if localStorage is available
export function isLocalStorageAvailable(): boolean {
  try {
    const test = '__localStorage_test__'
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch {
    return false
  }
}

// Safe localStorage getter
export function safeGetFromLocalStorage(key: string): string | null {
  if (!isLocalStorageAvailable()) {
    return null
  }

  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

// Safe localStorage setter
export function safeSetToLocalStorage(key: string, value: string): boolean {
  if (!isLocalStorageAvailable()) {
    return false
  }

  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}
